import { ActionType, getType } from 'typesafe-actions';

import * as config from '../../actionCreators/config';

export default function (
  state: FreeChoiceOrderingMethod | null = null,
  action: ActionType<typeof config>,
): FreeChoiceOrderingMethod | null {
  switch (action.type) {
    case getType(config.setFreeChoiceOrderingMethod): {
      const { value } = action.payload;
      return value || null;
    }
    default:
      return state;
  }
}
